module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-left-text-fill-2a9bc9dc.svg";